import React from 'react';
import Head from 'next/head';
import BaseLayout from 'layouts/BaseLayout';
import Script from 'next/script';
import { COLOR_WHITE } from 'styles/variables/colors';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import { withTranslations } from 'utils/withTranslations';

const DynamicHeader = dynamic(() => import('components/GraphicalAbstractMaker/Header'));
const DynamicMainContent = dynamic(() => import('components/GraphicalAbstractMaker/MainContent'));
const DynamicHeaderGraphicalAbstractMaker = dynamic(
  () => import('components/GraphicalAbstractMakerB/Header'),
);
const DynamicMainContentB = dynamic(() => import('components/GraphicalAbstractMakerB/MainContent'));

export default function GraphicalAbstractMakerPage() {
  const router = useRouter();
  const abTest = router.query.q === 'abtest';

  if (abTest) {
    return (
      <>
        <Head>
          <title>Graphical Abstract Maker: Create with Mind the Graph</title>

          <meta name="theme-color" content="#7833FF" />

          <meta
            key="description"
            name="description"
            content="Learn how to create effective graphical abstract to attract readers attention with Mind the Graph. Access right now and try for free!"
          />
        </Head>

        <DynamicHeaderGraphicalAbstractMaker />

        <DynamicMainContentB />
      </>
    );
  }

  return (
    <BaseLayout
      bgBrandColor={COLOR_WHITE}
      typeBtn="buttonSecondary"
      headerWhite={true}
      hasPadding={false}
      hero={<DynamicHeader />}
    >
      <Head>
        <title>Graphical Abstract Maker: Create with Mind the Graph</title>

        <meta
          key="description"
          name="description"
          content="Learn how to create effective graphical abstract to attract readers attention with Mind the Graph. Access right now and try for free!"
        />
      </Head>

      <Script src="https://www.googleoptimize.com/optimize.js?id=OPT-WCJ9RS5" />

      <DynamicMainContent />
    </BaseLayout>
  );
}
export const getStaticProps = withTranslations(['pricing', 'common']);
